export function formatDollars(value?: string) {
	if (value === undefined) return '—';
	return `$${Math.round(Number(value)).toLocaleString('en-US')}`;
}

export function formatPct(value?: string | null) {
	if (value === undefined || value === null || value === '') return '—';
	return `${value}%`;
}

/** Lower cycle time is better, so a negative delta is green. */
export function deltaClass(deltaDays?: string | null): string {
	if (deltaDays === undefined || deltaDays === null || deltaDays === '') {
		return 'text-slate-400';
	}
	const delta = Number(deltaDays);
	if (Number.isNaN(delta) || delta === 0) return 'text-slate-400';
	if (delta <= -1) return 'text-emerald-700';
	if (delta < 0) return 'text-emerald-600';
	if (delta < 1) return 'text-amber-600';
	return 'text-red-600';
}

export function deltaCopy(deltaDays?: string | null): string {
	if (deltaDays === undefined || deltaDays === null || deltaDays === '') {
		return 'No prior period';
	}
	const delta = Number(deltaDays);
	if (Number.isNaN(delta) || delta === 0) return 'Same as prior';
	const days = Math.abs(delta).toFixed(1);
	return delta < 0 ? `${days}d faster` : `${days}d slower`;
}
